import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import auth from './modules/auth'
import notification from './modules/notification'
import member from './modules/member'

const store = new Vuex.Store({
  modules: {
    auth,
    notification,
    member
  }
})

export default store
